const mitt = require('mitt').default;

const { createPromisesQueue, queueInputTypes } = require('./queue');

/**
 * @typedef {Object} EventEmitter
 * @property {function(string, function)} on Subscribe a handler to an event
 * @property {function(string, function)} off Unsubscribe a handler from an event
 * @property {function(string, any)} emit Emit an event with any data as payload (optional).
 */

/**
 * Create a lightweight asynchronous pub/sub event emitter
 * @returns {EventEmitter} New event emitter
 */
function createEventEmitter() {
  return mitt();
}

/**
 * Create a lightweight synchronous pub/sub event emitter.
 * Note: Every handler remains receiving the same data as payload.
 * @returns {EventEmitter} New event emitter
 */
function createSyncEventEmitter() {
  const queues = {};
  const existsQueue = (eventName) => eventName in queues;
  return {
    on(eventName, handler) {
      if (!existsQueue(eventName)) {
        queues[eventName] = createPromisesQueue({
          inputType: queueInputTypes.COMMON_INPUT,
        });
      }
      queues[eventName].add(handler);
    },
    off(eventName, handler) {
      queues[eventName]?.remove(handler);
    },
    emit(eventName, payload) {
      return queues[eventName]?.start(payload) ?? Promise.resolve();
    },
  };
}

module.exports = {
  createEventEmitter,
  createSyncEventEmitter,
};
